// SPDX-License-Identifier: AGPL-3.0-or-later

import PlannedUpdateNotice from '@app/features/app/state/PlannedUpdateNotice';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';
import styles from '@app/features/voice/components/alerts/PlannedUpdateToast.module.css';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {XIcon} from '@phosphor-icons/react';

export const PLANNED_UPDATE_TOAST_TIMEOUT_MS = 20_000;

const PLANNED_UPDATE_TOAST_DESCRIPTOR = msg({
	message: 'A short update is in progress. If you were dropped from voice, you can rejoin the channel.',
	comment:
		'Toast shown when the server restarts for a planned update while the user is in voice. Calm tone; it is not a crash.',
});

function PlannedUpdateToastContent() {
	const {i18n} = useLingui();
	return (
		<span className={styles.content} data-flx="voice.planned-update-toast.content">
			<span>{i18n._(PLANNED_UPDATE_TOAST_DESCRIPTOR)}</span>
			<span className={styles.close} aria-hidden="true" data-flx="voice.planned-update-toast.close">
				<XIcon weight="bold" />
			</span>
		</span>
	);
}

export function showPlannedUpdateToast(now = Date.now()): void {
	if (!PlannedUpdateNotice.claimToast(now)) {
		return;
	}
	ToastCommands.createToast({
		type: 'info',
		children: <PlannedUpdateToastContent />,
		timeout: PLANNED_UPDATE_TOAST_TIMEOUT_MS,
	});
}
